<template>
  <div class="ml-5 mr-5 set-margin-top mb-5">
    <div class="grid">
      <div class="grid">
        <div class="order-form-title w-full">Event Management</div>
        <div class="order-form-sub-title">{{ subtitle }}</div>
      </div>
      <div class="order-card w-full">
        <div class="grid">
          <div
            :class="{
              'md:col-5': multipleevents,
              'md:col-3': !multipleevents,
              'sm:col-11 col-9': true,
            }"
          >
            <DropDownRequire
              v-model="vmodel.customerid"
              :validation="v$.vmodel.customerid"
              :options="customerOption"
              id="customer"
              :filter="true"
              class="w-full"
              placeholder="Select Customer"
              label="Customer"
              optionLabel="name"
              optionValue="id"
            />
          </div>
          <div
            class="md:col-1 sm:col-1 col-3 p-0 mt-5 flex justify-content-center"
          >
            <PrimeButton
              class="download-button"
              icon="pi pi-plus"
              @click="showCustomerPopup = true"
            ></PrimeButton>
          </div>
          <div
            :class="{
              'md:col-6': multipleevents,
              'md:col-4': !multipleevents,
              'col-12': true,
            }"
          >
            <InputTextRequire
              :validation="v$.vmodel.name"
              v-model="vmodel.name"
              id="name"
              type="text"
              class="w-full"
              label="Event Name"
              placeholder="Enter Event Name"
            />
          </div>
          <div
            :class="{
              'md:col-6': multipleevents,
              'md:col-4': !multipleevents,
              'col-12': true,
            }"
          >
            <label for="date" class="form-label">
              {{ multipleevents ? "Date" : "Date and Time" }}
            </label>
            <Calendar
              v-if="!multipleevents"
              v-model="vmodel.date"
              id="date"
              type="text"
              class="w-full mt-2 mb-2"
              label=" Date and Time"
              showIcon
              showTime
              dateFormat="yy-mm-dd"
              :placeholder="
                multipleevents ? 'Select Date' : 'Select Date and Time'
              "
              :class="{
                'p-invalid': v$.vmodel.date.$error,
              }"
            />
            <Calendar
              v-else
              v-model="vmodel.date"
              id="date"
              type="text"
              class="w-full mt-2 mb-2"
              label=" Date and Time"
              showIcon
              dateFormat="yy-mm-dd"
              :placeholder="
                multipleevents ? 'Select Date' : 'Select Date and Time'
              "
              :class="{
                'p-invalid': v$.vmodel.date.$error,
              }"
            />
            <span
              v-if="v$.vmodel.date.$error && v$.vmodel.date.required.$invalid"
              id="date-help"
              class="p-error text-left"
            >
              {{
                multipleevents
                  ? "Date is required"
                  : "Date and Time is required"
              }}
            </span>
          </div>
          <div v-if="multipleevents" class="md:col-6 col-12">
            <DropDownRequire
              v-model="vmodel.status"
              :validation="v$.vmodel.status"
              :options="statusoption"
              id="status"
              :filter="true"
              optionLabel="name"
              placeholder="Select Status"
              optionValue="name"
              class="w-full"
              label="Status"
            />
          </div>
        </div>
        <div class="grid">
          <div
            class="col-12 flex sm:flex-row flex-column sm:justify-content-between"
          >
            <div class="sm:mt-0 mt-2">
              <Checkbox
                :binary="true"
                inputId="listed"
                v-model="multipleevents"
                @change="multipleEventSet"
              /><label for="listed" class="ml-2"> Multiple Events </label>
            </div>
            <div class="sm:mt-0 mt-2" v-if="multipleevents">
              <Checkbox
                :binary="true"
                inputId="listed"
                v-model="isSelectedRecipe"
                @change="emptyItemList"
              /><label for="listed" class="ml-2"> Include Recipe </label>
            </div>
          </div>
        </div>
        <div class="grid" v-if="!multipleevents">
          <div class="md:col-8 col-12">
            <InputTextRequire
              v-model="vmodel.venue"
              :validation="v$.vmodel.venue"
              id="venue"
              type="text"
              class="w-full"
              label="Venue"
              placeholder="Enter Venue"
              labelnotshow="false"
            />
          </div>
          <div class="md:col-2 col-12">
            <InputTextRequire
              v-model="vmodel.noofperson"
              :validation="v$.vmodel.noofperson"
              class="w-full"
              type="number"
              id="noofperson"
              label="Number Of Person"
              placeholder="Enter Person"
              :max="999999"
              @keydown="onlyDigit"
              @update:modelValue="setPerson()"
            />
          </div>
          <div class="md:col-2 col-12">
            <DropDownRequire
              v-model="vmodel.status"
              :validation="v$.vmodel.status"
              :options="statusoption"
              id="status"
              :filter="true"
              optionLabel="name"
              placeholder="Select Status"
              optionValue="name"
              class="w-full"
              label="Status"
            />
          </div>
        </div>
        <div class="grid col-12" v-if="!multipleevents">
          <div
            class="sm:col-4 col-12"
            v-for="(eventtype, index) in eventtypeOption"
            :id="index"
            :key="index"
          >
            <RadioButton
              :validation="v$.vmodel.eventtype"
              v-model="vmodel.eventtype"
              :inputId="`${eventtype}-option`"
              name="eventType"
              :value="`${eventtype}`"
            />
            <label class="ml-2 form-label" :for="`${eventtype}-option`">{{
              eventtype
            }}</label>
          </div>
          <span
            v-if="
              v$.vmodel.eventtype.$error &&
              v$.vmodel.eventtype.required.$invalid
            "
            id="eventtype-help"
            class="p-error text-left"
          >
            Event Type is required
          </span>
        </div>

        <div class="grid mt-2" v-if="!multipleevents">
          <div class="col-12">
            <div class="flex justify-content-between sm:flex-row flex-column">
              <label for="category" class="form-label">Recipe / Submenu</label>
              <div class="sm:mt-0 mt-2">
                <Checkbox
                  :binary="true"
                  inputId="listed"
                  v-model="isSelectedRecipe"
                  @change="emptyItemList"
                /><label for="listed" class="ml-2"> Include Recipe </label>
              </div>
            </div>
            <div id="box" class="box mt-3 flex gap-2 flex-column">
              <div
                class="grid mt-0 shadow-3 p-2 border-round-lg"
                v-for="(items, index) in vmodel.items"
                :id="index"
                :key="index"
              >
                <div class="col-12">
                  <div class="grid">
                    <div class="md:col-2 col-12 p-0">
                      <div class="grid m-0">
                        <div class="md:col-2 col-1 p-0 flex align-items-center">
                          <i
                            class="draggable-icon cursor-pointer mt-3"
                            :draggable="true"
                            @dragstart="dragStart(index)"
                            @dragover="dragOver(index)"
                            @drop="drop"
                          ></i>
                        </div>
                        <div class="md:col-10 col-10 p-0">
                          <label class="form-label">{{
                            isSelectedRecipe ? "Recipe" : "Submenu"
                          }}</label>
                          <Dropdown
                            v-model="vmodel.items[index].itemid"
                            :options="itemList"
                            :filter="true"
                            optionLabel="name"
                            optionValue="id"
                            id="materials"
                            :maxSelectedLabels="3"
                            placeholder="Select Recipe"
                            class="w-full mt-2 mb-2"
                            v-if="isSelectedRecipe"
                            :class="{
                              'p-invalid':
                                v$.vmodel.items.$each.$response.$errors[index]
                                  .itemid[0] && validated,
                            }"
                            @update:modelValue="getItemListDetails(index)"
                          />
                          <CascadeSelect
                            v-model="vmodel.items[index].itemid"
                            :options="
                              itemList.length > 0
                                ? itemList
                                : [
                                    {
                                      id: 'No available options',
                                      name: 'No available options',
                                      disabled: true,
                                    },
                                  ]
                            "
                            optionLabel="name"
                            optionDisabled="disabled"
                            optionGroupLabel="name"
                            optionValue="id"
                            :optionGroupChildren="['submenu']"
                            class="w-full mt-2 mb-2"
                            placeholder="Select Submenu"
                            v-else
                            @update:modelValue="getItemListDetails(index)"
                            :class="{
                              'p-invalid':
                                v$.vmodel.items.$each.$response.$errors[index]
                                  .itemid[0] && validated,
                            }"
                          />
                          <span
                            v-if="
                              v$.vmodel.items.$each.$response.$errors[index]
                                .itemid[0] && validated
                            "
                            id="itemid[index]-help"
                            class="p-error text-left"
                          >
                            {{ isSelectedRecipe ? "Recipe" : "Submenu" }} is
                            required
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="sm:col-1 col-3 p-1 mt-4 flex justify-content-center"
                    >
                      <PrimeButton
                        class="download-button"
                        icon="pi pi-plus"
                        @click="openRecipePopup(index)"
                        v-if="isSelectedRecipe"
                      ></PrimeButton>
                      <PrimeButton
                        class="download-button"
                        icon="pi pi-plus"
                        @click="openSubMenuPopup(index)"
                        v-else
                      ></PrimeButton>
                    </div>
                    <div
                      class="form-label flex flex-column md:align-items-start align-items-center pl-2"
                    >
                      <label class="mb-4">Inbound/Outbound</label>
                      <label class="switch">
                        <Checkbox
                          :binary="true"
                          v-model="vmodel.items[index].checked"
                          class="p-cart"
                          @change="vendorChecked(index)"
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div
                      class="lg:col-2 md:col-5 col-12 p-0 pad-check"
                      v-if="vmodel.items[index].checked"
                    >
                      <DropdownCustom
                        v-model="vmodel.items[index].vendorid"
                        :validation="
                          v$.vmodel.items.$each.$response.$errors[index]
                            .vendorid[0]
                        "
                        :options="voption"
                        optionLabel="name"
                        optionValue="id"
                        :filter="true"
                        id="vendor"
                        label="Vendor"
                        :showlabel="true"
                        placeholder="Select Vendor"
                        :customfield="true"
                        :validated="validated"
                      />
                    </div>
                    <div
                      class="lg:col-1 p-0 mt-4 pad-check"
                      v-if="vmodel.items[index].checked"
                    >
                      <PrimeButton
                        class="download-button"
                        icon="pi pi-plus"
                        @click="openVendorPopup(index)"
                      ></PrimeButton>
                    </div>
                    <div class="lg:col-1 md:col-2 col-12 mb-3 p-0 pad-check">
                      <!-- <label class="form-label">Person</label> -->
                      <NumberCustom
                        type="text"
                        v-model="vmodel.items[index].people"
                        :validation="
                          v$.vmodel.items.$each.$response.$errors[index]
                            .people[0]
                        "
                        label="Person"
                        id="Person"
                        placeholder="0"
                        :min="0"
                        :max="9999999"
                        maxLangth="6"
                        :customfield="true"
                        :validated="validated"
                      />
                    </div>
                    <div
                      :class="
                        vmodel.items[index].checked
                          ? 'lg:col-2 md:col-5 sm:col-11 col-12 p-0 pad-check'
                          : 'lg:col-3 md:col-6 col-12 p-0 pad-check'
                      "
                    >
                      <InputGroup
                        type="text"
                        v-model="vmodel.items[index].remarks"
                        :validation="
                          v$.vmodel.items.$each.$response.$errors[index]
                            .remarks[0]
                        "
                        class="w-full remarksnote"
                        id="remarks"
                        label="Remark"
                        placeholder="Remark"
                        :customfield="true"
                        :validated="validated"
                      />
                    </div>
                    <div
                      class="md:col-2 col-12 flex bin-btn justify-content-end relative p-0"
                      :class="
                        vmodel.items[index].checked
                          ? 'lg:col-1 md:col-2'
                          : 'lg:col-3 md:col-2'
                      "
                    >
                      <PrimeButton
                        icon="bin-icon"
                        class="bin-button"
                        @click="removeItem(index)"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="col-12"
                  v-if="isSelectedRecipe && vmodel.items[index].itemid"
                >
                  <div class="grid">
                    <div
                      class="form-label flex flex-column md:align-items-start align-items-center pl-2"
                    >
                      <label class="mb-4">Set Manual Recipe Qty</label>
                      <label class="switch">
                        <Checkbox
                          :binary="true"
                          v-model="vmodel.items[index].edited"
                          class="p-cart"
                          @change="editedRecipeChecked(index)"
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div
                      class="sm:col-3 col-12 p-1 sm:mt-4 mt-1 flex justify-content-center"
                      v-if="vmodel.items[index].edited"
                    >
                      <PrimeButton
                        class="download-button"
                        label="Edit Recipe Qty"
                        icon="pi pi-pencil"
                        @click="openRecipeEditPopup(index)"
                      ></PrimeButton>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid mt-1">
                <div class="col-4 field">
                  <PrimeButton
                    icon="pi pi-plus"
                    class="add-item-button"
                    @click="repeateAgain()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div id="box" class="mt-3 flex gap-2 flex-column">
            <div
              class="grid mt-0 shadow-3 p-2 border-round-lg"
              v-for="(event, eventindex) in vmodel.events"
              :id="eventindex"
              :key="eventindex"
            >
              <div class="sm:col-4 col-12">
                <TextCustom
                  type="text"
                  v-model="vmodel.events[eventindex].venue"
                  :validation="
                    v$.vmodel.events.$each.$response.$errors[eventindex]
                      .venue[0]
                  "
                  label="Venue"
                  id="eventvenue"
                  placeholder="Enter Venue"
                  :customfield="true"
                  :validated="validated"
                />
              </div>
              <div class="sm:col-4 col-11">
                <NumberCustom
                  type="text"
                  v-model="vmodel.events[eventindex].people"
                  :validation="
                    v$.vmodel.events.$each.$response.$errors[eventindex]
                      .people[0]
                  "
                  label="People"
                  id="People"
                  placeholder="0"
                  :min="0"
                  :max="9999999"
                  maxLangth="4"
                  :customfield="true"
                  :validated="validated"
                  @update:modelValue="setPersonMultipleEvent(eventindex)"
                />
              </div>
              <div class="md:col-3 col-12">
                <InputCustomDate
                  v-model="vmodel.events[eventindex].time"
                  :validation="
                    v$.vmodel.events.$each.$response.$errors[eventindex].time[0]
                  "
                  class="w-full"
                  label="Event Time"
                  id="eventtime"
                  placeholder="Enter Time"
                  :customfield="true"
                  :validated="validated"
                />
              </div>
              <div class="sm:col-1 col-1">
                <PrimeButton
                  icon="bin-icon"
                  v-if="vmodel.events.length > 1"
                  class="bin-button p-default-button"
                  @click="removeItemEvent(eventindex)"
                />
              </div>
              <div class="grid col-12 ml-1">
                <div
                  class="grid col-4"
                  v-for="(eventtype, index) in eventtypeOption"
                  :id="index"
                  :key="index"
                >
                  <RadioButton
                    v-model="vmodel.events[eventindex].eventtype"
                    :inputId="`${eventtype}-option`"
                    name="eventType"
                    :value="`${eventtype}`"
                  />
                  <label class="ml-2 form-label" :for="`${eventtype}-option`">{{
                    eventtype
                  }}</label>
                </div>
                <div class="col-12 flex justify-content-start p-0">
                  <span
                    v-if="
                      validated &&
                      v$.vmodel.events.$each.$response.$errors[eventindex]
                        .eventtype[0]
                    "
                    class="p-error text-left mt-2"
                  >
                    Event Type is required
                  </span>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="flex justify-content-between sm:flex-row flex-column"
                >
                  <label for="category" class="form-label"
                    >Recipe / Submenu</label
                  >
                </div>
                <div id="box" class="box mt-3 flex gap-2 flex-column">
                  <div
                    class="grid mt-0 shadow-3 p-2 border-round-lg"
                    v-for="(items, index) in vmodel.events[eventindex].items"
                    :id="index"
                    :key="index"
                  >
                    <div class="col-12">
                      <div class="grid">
                        <div class="md:col-2 col-12 p-0">
                          <div class="grid m-0">
                            <div
                              class="md:col-2 col-1 p-0 flex align-items-center"
                            >
                              <i
                                class="draggable-icon cursor-pointer mt-3"
                                :draggable="true"
                                @dragstart="
                                  dragStartMultiEvent(eventindex, index)
                                "
                                @dragover="
                                  dragOverMultiEvent(eventindex, index)
                                "
                                @drop="dropMultiEvent"
                              ></i>
                            </div>
                            <div class="md:col-10 col-10 p-0">
                              <label class="form-label">{{
                                isSelectedRecipe ? "Recipe" : "Submenu"
                              }}</label>
                              <Dropdown
                                v-model="
                                  vmodel.events[eventindex].items[index].itemid
                                "
                                :options="itemList"
                                :filter="true"
                                optionLabel="name"
                                optionValue="id"
                                id="materials"
                                :maxSelectedLabels="3"
                                placeholder="Select Recipe"
                                class="w-full mt-2 mb-2"
                                v-if="isSelectedRecipe"
                                :class="{
                                  'p-invalid':
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items &&
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items.length > 0 &&
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items[0].$response.$errors[index]
                                      .itemid[0] &&
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items[0].$response.$errors[index]
                                      .itemid[0].$message &&
                                    validated,
                                }"
                                @update:modelValue="
                                  getEventItemListDetails(index, eventindex)
                                "
                              />
                              <!--  -->
                              <CascadeSelect
                                v-model="
                                  vmodel.events[eventindex].items[index].itemid
                                "
                                :options="
                                  itemList.length > 0
                                    ? itemList
                                    : [
                                        {
                                          id: 'No available options',
                                          name: 'No available options',
                                          disabled: true,
                                        },
                                      ]
                                "
                                optionLabel="name"
                                optionDisabled="disabled"
                                optionGroupLabel="name"
                                optionValue="id"
                                :optionGroupChildren="['submenu']"
                                class="w-full mt-2 mb-2"
                                placeholder="Select Submenu"
                                v-else
                                :class="{
                                  'p-invalid':
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items &&
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items.length > 0 &&
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items[0].$response.$errors[index]
                                      .itemid[0] &&
                                    v$.vmodel.events.$each.$response.$errors[
                                      eventindex
                                    ].items[0].$response.$errors[index]
                                      .itemid[0].$message &&
                                    validated,
                                }"
                                @update:modelValue="
                                  getEventItemListDetails(index, eventindex)
                                "
                              />
                              <span
                                v-if="
                                  v$.vmodel.events.$each.$response.$errors[
                                    eventindex
                                  ].items &&
                                  v$.vmodel.events.$each.$response.$errors[
                                    eventindex
                                  ].items.length > 0 &&
                                  v$.vmodel.events.$each.$response.$errors[
                                    eventindex
                                  ].items[0].$response.$errors[index]
                                    .itemid[0] &&
                                  v$.vmodel.events.$each.$response.$errors[
                                    eventindex
                                  ].items[0].$response.$errors[index].itemid[0]
                                    .$message &&
                                  validated
                                "
                                id="itemid[index]-help"
                                class="p-error text-left"
                              >
                                {{ isSelectedRecipe ? "Recipe" : "Submenu" }}
                                is required
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="sm:col-1 col-3 p-1 mt-4 flex justify-content-center"
                        >
                          <PrimeButton
                            class="download-button"
                            icon="pi pi-plus"
                            @click="
                              openRecipePopupMultipleEvents(eventindex, index)
                            "
                            v-if="isSelectedRecipe"
                          ></PrimeButton>
                          <PrimeButton
                            class="download-button"
                            icon="pi pi-plus"
                            @click="
                              openSubMenuPopupMultipleEvents(eventindex, index)
                            "
                            v-else
                          ></PrimeButton>
                        </div>
                        <div
                          class="form-label flex flex-column md:align-items-start align-items-center pl-2"
                        >
                          <label class="mb-4">Inbound/Outbound</label>
                          <label class="switch">
                            <Checkbox
                              :binary="true"
                              v-model="
                                vmodel.events[eventindex].items[index].checked
                              "
                              class="p-cart"
                              @change="
                                vendorCheckedMultipleEvents(eventindex, index)
                              "
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <div
                          class="lg:col-2 md:col-5 col-12 p-0 pad-check"
                          v-if="vmodel.events[eventindex].items[index].checked"
                        >
                          <DropdownCustom
                            v-model="
                              vmodel.events[eventindex].items[index].vendorid
                            "
                            :options="voption"
                            optionLabel="name"
                            optionValue="id"
                            :filter="true"
                            id="vendor"
                            label="Vendor"
                            :showlabel="true"
                            placeholder="Select Vendor"
                            :customfield="true"
                            :validated="validated"
                            :validation="
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items &&
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items.length > 0 &&
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items[0].$response.$errors[index].vendorid[0]
                            "
                          />
                        </div>
                        <div
                          class="lg:col-1 p-0 mt-4 pad-check"
                          v-if="vmodel.events[eventindex].items[index].checked"
                        >
                          <PrimeButton
                            class="download-button"
                            icon="pi pi-plus"
                            @click="
                              openMultiEventVendorPopup(eventindex, index)
                            "
                          ></PrimeButton>
                        </div>
                        <div
                          class="lg:col-1 md:col-2 col-12 mb-3 p-0 pad-check"
                        >
                          <!-- <label class="form-label">Person</label> -->
                          <NumberCustom
                            type="text"
                            v-model="
                              vmodel.events[eventindex].items[index].people
                            "
                            label="Person"
                            id="Person"
                            placeholder="0"
                            :min="0"
                            :max="9999999"
                            maxLangth="6"
                            :customfield="true"
                            :validated="validated"
                            :validation="
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items &&
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items.length > 0 &&
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items[0].$response.$errors[index].people[0]
                            "
                          />
                        </div>
                        <div
                          :class="
                            vmodel.events[eventindex].items[index].checked
                              ? 'lg:col-2 md:col-5 sm:col-11 col-12 p-0 pad-check'
                              : 'lg:col-3 md:col-6 col-12 p-0 pad-check'
                          "
                        >
                          <InputGroup
                            type="text"
                            v-model="
                              vmodel.events[eventindex].items[index].remarks
                            "
                            class="w-full remarksnote"
                            id="remarks"
                            label="Remark"
                            placeholder="Remark"
                            :customfield="true"
                            :validated="validated"
                            :validation="
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items &&
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items.length > 0 &&
                              v$.vmodel.events.$each.$response.$errors[
                                eventindex
                              ].items[0].$response.$errors[index].remarks[0]
                            "
                          />
                        </div>
                        <div
                          class="md:col-2 col-12 flex bin-btn justify-content-end relative p-0"
                          :class="
                            vmodel.events[eventindex].items[index].checked
                              ? 'lg:col-1 md:col-2'
                              : 'lg:col-3 md:col-2'
                          "
                        >
                          <PrimeButton
                            icon="bin-icon"
                            class="bin-button"
                            @click="removeEventItem(eventindex, index)"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      v-if="
                        isSelectedRecipe &&
                        vmodel.events[eventindex].items[index].itemid
                      "
                    >
                      <div class="grid">
                        <div
                          class="form-label flex flex-column md:align-items-start align-items-center pl-2"
                        >
                          <label class="mb-4">Set Manual Recipe Qty</label>
                          <label class="switch">
                            <Checkbox
                              :binary="true"
                              v-model="
                                vmodel.events[eventindex].items[index].edited
                              "
                              class="p-cart"
                              @change="
                                editedRecipeCheckedMultipleEvents(
                                  eventindex,
                                  index
                                )
                              "
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <div
                          class="sm:col-3 col-12 p-1 sm:mt-4 mt-1 flex justify-content-center"
                          v-if="vmodel.events[eventindex].items[index].edited"
                        >
                          <PrimeButton
                            class="download-button"
                            label="Edit Recipe Qty"
                            icon="pi pi-pencil"
                            @click="
                              openRecipeEditPopupMultipleEvents(
                                eventindex,
                                index
                              )
                            "
                          ></PrimeButton>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid mt-1">
                    <div class="col-4 field">
                      <PrimeButton
                        icon="pi pi-plus"
                        class="add-item-button"
                        @click="repeateAgainEventItem(eventindex)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid mt-1">
              <div class="col-4 field">
                <PrimeButton
                  v-if="vmodel.events.length < 4"
                  icon="pi pi-plus"
                  class="add-item-button"
                  @click="repeateAgainEvent()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="grid mx-0 mt-4">
          <div class="col-12 flex set-button">
            <PrimeButton
              label="Add"
              class="order-form-button"
              v-if="!isEditMode"
              @click="createEvent"
            >
            </PrimeButton>
            <PrimeButton
              label="Edit"
              class="order-form-button"
              v-else
              @click="createEvent"
            >
            </PrimeButton>
            <PrimeButton
              label="Cancel"
              class="form-cancel-button sm:ml-2"
              @click="onCancel"
            ></PrimeButton>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CustomerAddPopup
    :show-popup="showCustomerPopup"
    @displayNo="closeCustomerPopup()"
    @displayYes="checkCustomer"
  ></CustomerAddPopup>
  <SubMenuAddPopup
    :show-popup="showSubMenuPopup"
    @displayNo="closeSubMenuPopup()"
    @displayYes="checkSubMenu"
  ></SubMenuAddPopup>
  <RecipeAddPopup
    :show-popup="showRecipePopup"
    :noofperson="noofpersons"
    @displayNo="closeRecipePopup()"
    @displayYes="checkRecipe"
  ></RecipeAddPopup>
  <VendorAddPopup
    :show-popup="showVendorPopup"
    @displayNo="closeVendorPopup()"
    @displayYes="checkVendor"
  ></VendorAddPopup>
  <RecipeEditPopup
    :show-popup="showEditRecipePopup"
    :recipeId="currentRecipeId"
    :people="currentSelectedPerson"
    :editeditems="editeditems"
    @displayNo="closeRecipeEditPopup()"
    @displayYes="checkEditRecipe"
  ></RecipeEditPopup>
</template>

<script>
import APIService from "@/services/api-service.js";
import DateFormat from "@/libs/DateFormat";
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  maxLength,
  numeric,
  maxValue,
  minValue,
  helpers,
  requiredIf,
} from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      subtitle: "Add Event",
      datetime12h: null,
      dragIndex: null,
      dragMultiEventIndex: null,
      currentRecipeId: "",
      currentSelectedPerson: 1,
      noofpersons: "1",
      isEditMode: false,
      customerOption: [],
      eventtypeOption: [],
      multipleevents: false,
      item: [],
      editeditems: [],
      addedEventItemList: [],
      addedItemList: [],
      itemList: [],
      items: [],
      voption: [],
      showCustomerPopup: false,
      showSubMenuPopup: false,
      showRecipePopup: false,
      showVendorPopup: false,
      isSelectedRecipe: false,
      showEditRecipePopup: false,
      validated: false,
      openIndex: "",
      openMultipleEventIndex: "",
      statusoption: [
        { name: "Inquiry" },
        { name: "Confirm" },
        { name: "Cancel" },
      ],
      title: "Add",
      vmodel: {
        customerid: "",
        name: "",
        noofperson: 1,
        status: "",
        venue: "",
        date: "",
        eventtype: "",
        items: [
          {
            name: "",
            itemid: "",
            menuid: "",
            menuname: "",
            checked: false,
            vendorid: "",
            people: 1,
            remarks: "",
            editeditems: [],
          },
        ],
        events: [],
      },
    };
  },
  validations() {
    if (this.multipleevents) {
      return {
        vmodel: {
          customerid: { required },
          name: { required, max: maxLength(40) },
          noofperson: {
            numeric,
            min: minValue(1),
            max: maxValue(999999),
          },
          eventtype: {},
          status: { required },
          venue: { max: maxLength(200) },
          date: { required },
          events: {
            $each: helpers.forEach({
              eventtype: { required },
              time: { required },
              people: {
                required,
                numeric,
                min: minValue(1),
                max: maxValue(999999),
              },
              venue: { required, max: maxLength(200) },
              items: {
                $each: helpers.forEach({
                  itemid: { required },
                  people: {
                    required,
                    numeric,
                    min: minValue(1),
                    max: maxValue(99999),
                  },
                  vendorid: {
                    requiredIf: requiredIf((items, index) => {
                      return index.checked;
                    }),
                  },
                  remarks: { max: maxLength(50) },
                  editeditems: {},
                }),
              },
            }),
          },
        },
      };
    } else {
      return {
        vmodel: {
          customerid: { required },
          name: { required, max: maxLength(40) },
          noofperson: {
            required,
            numeric,
            min: minValue(1),
            max: maxValue(999999),
          },
          eventtype: { required },
          status: { required },
          venue: { required, max: maxLength(200) },
          date: { required },
          items: {
            $each: helpers.forEach({
              itemid: { required },
              people: {
                required,
                numeric,
                min: minValue(1),
                max: maxValue(99999),
              },
              vendorid: {
                requiredIf: requiredIf((items, index) => {
                  return index.checked;
                }),
              },
              remarks: { max: maxLength(50) },
              editeditems: {},
            }),
          },
        },
      };
    }
  },
  async created() {
    await this.getEventType();
  },
  async mounted() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    if (this.$route.params.id) {
      this.subtitle = "Update Event";
      this.isEditMode = true;
      await this.getEventById();
    }
    if (this.isSelectedRecipe) {
      await this.getRecipe();
    } else {
      await this.getsubmenu();
    }
    this.$root.$globalState.loader = false;
    await this.getCustomerDrop();
    await this.getVendor();
  },
  methods: {
    async getEventType() {
      this.$root.$globalState.loader = true;
      await APIService.get("/company/eventtype")
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.eventtypeOption = response.data.data;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
          this.submitted = false;
        });
    },
    setPersonMultipleEvent(eventindex) {
      if (this.vmodel.events && this.vmodel.events.length > 0) {
        if (
          this.vmodel.events[eventindex] &&
          this.vmodel.events[eventindex].items &&
          this.vmodel.events[eventindex].items.length > 0
        ) {
          for (let item of this.vmodel.events[eventindex].items) {
            item.people = this.vmodel.events[eventindex].people;
          }
        }
      }
    },
    setPerson() {
      if (this.vmodel.items) {
        for (let item of this.vmodel.items) {
          item.people = this.vmodel.noofperson;
        }
      }
    },
    dragStartMultiEvent(eventindex, index) {
      this.dragIndex = index;
      this.dragMultiEventIndex = eventindex;
    },
    dragOverMultiEvent(eventindex, index) {
      if (this.dragIndex !== null && this.dragMultiEventIndex !== null) {
        const draggedItem = this.vmodel.events[eventindex].items.splice(
          this.dragIndex,
          1
        )[0];
        this.vmodel.events[eventindex].items.splice(index, 0, draggedItem);
        this.dragIndex = index;
        this.dragMultiEventIndex = eventindex;
      }
    },
    dropMultiEvent() {
      this.dragIndex = null;
      this.dragMultiEventIndex = null;
    },
    dragStart(index) {
      this.dragIndex = index;
    },
    dragOver(index) {
      if (this.dragIndex !== null) {
        const draggedItem = this.vmodel.items.splice(this.dragIndex, 1)[0];
        this.vmodel.items.splice(index, 0, draggedItem);
        this.dragIndex = index;
      }
    },
    drop() {
      this.dragIndex = null;
    },
    closeCustomerPopup() {
      this.showCustomerPopup = false;
    },
    async checkCustomer(data) {
      this.showCustomerPopup = false;
      this.vmodel.customerid = data;
      await this.getCustomerDrop();
    },
    openRecipeEditPopupMultipleEvents(eventindex, index) {
      this.editeditems = [];
      this.showEditRecipePopup = true;
      this.openIndex = index;
      this.openMultipleEventIndex = eventindex;
      this.editeditems =
        this.vmodel.events[eventindex].items[index].editeditems || [];
      this.currentRecipeId = this.vmodel.events[eventindex].items[index].itemid;
      this.currentSelectedPerson =
        this.vmodel.events[eventindex].items[index].people;
    },
    openRecipeEditPopup(index) {
      this.editeditems = [];
      this.showEditRecipePopup = true;
      this.openIndex = index;
      this.editeditems = this.vmodel.items[index].editeditems || [];
      this.currentRecipeId = this.vmodel.items[index].itemid;
      this.currentSelectedPerson = this.vmodel.items[index].people;
    },
    closeRecipeEditPopup() {
      this.showEditRecipePopup = false;
    },
    async checkEditRecipe(data) {
      if (this.multipleevents) {
        this.vmodel.events[this.openMultipleEventIndex].items[
          this.openIndex
        ].editeditems = data;
        this.editeditems = data;
        this.showRecipePopup = false;
      } else {
        this.vmodel.items[this.openIndex].editeditems = data;
        this.editeditems = data;
        this.showRecipePopup = false;
      }
    },
    openRecipePopupMultipleEvents(eventindex, index) {
      this.noofpersons =
        this.vmodel.events[eventindex].items[index].people.toString() ||
        this.vmodel.noofperson;
      this.openIndex = index;
      this.openMultipleEventIndex = eventindex;
      this.$nextTick(() => {
        this.showRecipePopup = true;
      });
    },
    openRecipePopup(index) {
      this.noofpersons = this.vmodel.items[index].people;
      // this.showRecipePopup = true;
      this.openIndex = index;
      this.$nextTick(() => {
        this.showRecipePopup = true;
      });
    },
    closeRecipePopup() {
      this.showRecipePopup = false;
    },
    async checkRecipe(data) {
      this.showRecipePopup = false;
      await this.getRecipe();
      await this.getVendor();
      await this.setRecipeDetails(data);
      // if (this.isSelectedRecipe) {
      //   this.items
      //     .filter((x) => x.id === this.vmodel.items[index].itemid)
      //     .map((data) => {
      //       this.vmodel.items[index].recipeid = this.vmodel.items[index].itemid;
      //       this.vmodel.items[index].recipename = data.name;
      //       this.vmodel.items[index].people = this.vmodel.noofperson;
      //       this.vmodel.items[index].remarks = "";
      //     });
      // } else {
      //   this.items
      //     .filter((x) =>
      //       x.submenu.some(
      //         (subElement) => subElement.id === this.vmodel.items[index].itemid
      //       )
      //     )
      //     .map((element) => {
      //       element.sub = element.submenu
      //         .filter(
      //           (subElement) =>
      //             subElement.id === this.vmodel.items[index].itemid
      //         )
      //         .map((x) => {
      //           let newElt = Object.assign({}, x);
      //           return newElt;
      //         });
      //       this.vmodel.items[index].submenuid = element.sub[0].id;
      //       this.vmodel.items[index].name = element.sub[0].name;
      //       this.vmodel.items[index].menuid = element.sub[0].menuid;
      //       this.vmodel.items[index].menuname = element.name;
      //       this.vmodel.items[index].people = this.vmodel.noofperson;
      //       this.vmodel.items[index].remarks = "";
      //     });
      // }
      // if (this.vmodel.items) {
      //   let index = this.vmodel.items.length - 1;
      //   this.vmodel.items[index].itemid = data;
      //   this.getItemListDetails(index);
      // }
    },
    async setRecipeDetails(data) {
      if (this.multipleevents) {
        if (this.vmodel.events) {
          let eventindex = this.openMultipleEventIndex;
          if (this.vmodel.events[eventindex].items) {
            let index = this.openIndex;
            if (this.vmodel.events[eventindex].items[index].itemid == "") {
              this.vmodel.events[eventindex].items[index].itemid = data;
              this.vmodel.events[eventindex].items[index].recipeid = data;
              await this.itemList
                .filter((x) => x.id == data)
                .map((data) => {
                  this.vmodel.events[eventindex].items[index].recipename =
                    data.name;
                  this.vmodel.events[eventindex].items[index].people =
                    this.vmodel.noofperson;
                  this.vmodel.events[eventindex].items[index].vendorid = "";
                  this.vmodel.events[eventindex].items[index].remarks = "";
                  this.vmodel.events[eventindex].items[index].checked = false;
                  this.vmodel.events[eventindex].items[index].edited = false;
                  this.vmodel.events[eventindex].items[index].editeditems = [];
                });
            }
            // } else {
            //   const newItem = {
            //     recipename: "",
            //     itemid: "",
            //     recipeid: "",
            //     people: 1,
            //     vendorid: "",
            //     remarks: "",
            //     checked: false,
            //   };
            //   this.vmodel.items = [...this.vmodel.items, newItem];
            //   index = this.vmodel.items.length - 1;
            //   this.vmodel.items[index].itemid = data;
            //   this.vmodel.items[index].recipeid = data;
            //   await this.itemList
            //     .filter((x) => x.id == data)
            //     .map((data) => {
            //       this.vmodel.items[index].recipename = data.name;
            //       this.vmodel.items[index].people = 1;
            //       this.vmodel.items[index].vendorid = "";
            //       this.vmodel.items[index].remarks = "";
            //       this.vmodel.items[index].checked = false;
            //     });
            // }
            await this.getEventItemListDetails(index, eventindex);
          }
          this.openIndex = "";
          this.openMultipleEventIndex = "";
        }
      } else {
        if (this.vmodel.items) {
          let index = this.openIndex;
          if (this.vmodel.items[index].itemid == "") {
            this.vmodel.items[index].itemid = data;
            this.vmodel.items[index].recipeid = data;
            await this.itemList
              .filter((x) => x.id == data)
              .map((data) => {
                this.vmodel.items[index].recipename = data.name;
                this.vmodel.items[index].people = this.vmodel.noofperson;
                this.vmodel.items[index].vendorid = "";
                this.vmodel.items[index].remarks = "";
                this.vmodel.items[index].checked = false;
                this.vmodel.items[index].edited = false;
                this.vmodel.items[index].editeditems = [];
              });
          }
          // } else {
          //   const newItem = {
          //     recipename: "",
          //     itemid: "",
          //     recipeid: "",
          //     people: 1,
          //     vendorid: "",
          //     remarks: "",
          //     checked: false,
          //   };
          //   this.vmodel.items = [...this.vmodel.items, newItem];
          //   index = this.vmodel.items.length - 1;
          //   this.vmodel.items[index].itemid = data;
          //   this.vmodel.items[index].recipeid = data;
          //   await this.itemList
          //     .filter((x) => x.id == data)
          //     .map((data) => {
          //       this.vmodel.items[index].recipename = data.name;
          //       this.vmodel.items[index].people = 1;
          //       this.vmodel.items[index].vendorid = "";
          //       this.vmodel.items[index].remarks = "";
          //       this.vmodel.items[index].checked = false;
          //     });
          // }
          await this.getItemListDetails(index);
        }
        this.openIndex = "";
      }
    },
    openSubMenuPopupMultipleEvents(eventindex, index) {
      this.openIndex = index;
      this.openMultipleEventIndex = eventindex;
      this.showSubMenuPopup = true;
    },
    openSubMenuPopup(index) {
      this.openIndex = index;
      this.showSubMenuPopup = true;
    },
    closeSubMenuPopup() {
      this.showSubMenuPopup = false;
    },
    async checkSubMenu(data) {
      this.showSubMenuPopup = false;
      await this.getsubmenu();
      await this.getVendor();
      await this.setSubmenu(data);
      // if (this.vmodel.items) {
      //   let index = this.vmodel.items.length - 1;
      //   this.vmodel.items[index].itemid = data;
      //   this.getItemListDetails(index);
      // }
    },
    async setSubmenu(data) {
      if (this.multipleevents) {
        if (this.vmodel.events) {
          let eventindex = this.openMultipleEventIndex;
          if (this.vmodel.events[eventindex].items) {
            if (
              this.vmodel.events[eventindex].items[this.openIndex].itemid == ""
            ) {
              this.vmodel.events[eventindex].items[this.openIndex].itemid =
                data;
              await this.items
                .filter((x) =>
                  x.submenu.some((subElement) => subElement.id == data)
                )
                .map((element) => {
                  element.sub = element.submenu
                    .filter((subElement) => subElement.id == data)
                    .map((x) => {
                      let newElt = Object.assign({}, x);
                      return newElt;
                    });
                  this.vmodel.events[eventindex].items[
                    this.openIndex
                  ].submenuid = element.sub[0].id;
                  this.vmodel.events[eventindex].items[this.openIndex].name =
                    element.sub[0].name;
                  this.vmodel.events[eventindex].items[this.openIndex].menuid =
                    element.sub[0].menuid;
                  this.vmodel.events[eventindex].items[
                    this.openIndex
                  ].menuname = element.name;
                  this.vmodel.events[eventindex].items[this.openIndex].people =
                    this.vmodel.noofperson;
                  this.vmodel.events[eventindex].items[this.openIndex].remarks =
                    "";
                  this.vmodel.events[eventindex].items[
                    this.openIndex
                  ].checked = false;
                  this.vmodel.events[eventindex].items[
                    this.openIndex
                  ].edited = false;
                  this.vmodel.events[eventindex].items[
                    this.openIndex
                  ].editeditems = [];
                });
            }
            // else {
            //   const newItem = {
            //     name: "",
            //     itemid: "",
            //     submenuid: "",
            //     menuid: "",
            //     menuname: "",
            //     people: 1,
            //     vendorid: "",
            //     remarks: "",
            //     checked: false,
            //   };
            //   this.vmodel.items = [...this.vmodel.items, newItem];
            //   index = this.vmodel.items.length - 1;
            //   this.vmodel.items[index].itemid = data;
            //   await this.items
            //     .filter((x) =>
            //       x.submenu.some(
            //         (subElement) =>
            //           subElement.id === this.vmodel.items[index].itemid
            //       )
            //     )
            //     .map((element) => {
            //       element.sub = element.submenu
            //         .filter((subElement) => subElement.id == data)
            //         .map((x) => {
            //           let newElt = Object.assign({}, x);
            //           return newElt;
            //         });
            //       this.vmodel.items[index].submenuid = element.sub[0].id;
            //       this.vmodel.items[index].name = element.sub[0].name;
            //       this.vmodel.items[index].menuid = element.sub[0].menuid;
            //       this.vmodel.items[index].menuname = element.name;
            //       this.vmodel.items[index].people = this.vmodel.noofperson;
            //       this.vmodel.items[index].remarks = "";
            //       this.vmodel.items[index].checked = false;
            //     });
            // }
            await this.getEventItemListDetails(
              this.openIndex,
              this.openMultipleEventIndex
            );
          }
          this.openIndex = "";
          this.openMultipleEventIndex = "";
        }
      } else {
        if (this.vmodel.items) {
          if (this.vmodel.items[this.openIndex].itemid == "") {
            this.vmodel.items[this.openIndex].itemid = data;
            await this.items
              .filter((x) =>
                x.submenu.some((subElement) => subElement.id == data)
              )
              .map((element) => {
                element.sub = element.submenu
                  .filter((subElement) => subElement.id == data)
                  .map((x) => {
                    let newElt = Object.assign({}, x);
                    return newElt;
                  });
                this.vmodel.items[this.openIndex].submenuid = element.sub[0].id;
                this.vmodel.items[this.openIndex].name = element.sub[0].name;
                this.vmodel.items[this.openIndex].menuid =
                  element.sub[0].menuid;
                this.vmodel.items[this.openIndex].menuname = element.name;
                this.vmodel.items[this.openIndex].people =
                  this.vmodel.noofperson;
                this.vmodel.items[this.openIndex].remarks = "";
                this.vmodel.items[this.openIndex].checked = false;
                this.vmodel.items[this.openIndex].edited = false;
                this.vmodel.items[this.openIndex].editeditems = [];
              });
          }
          // else {
          //   const newItem = {
          //     name: "",
          //     itemid: "",
          //     submenuid: "",
          //     menuid: "",
          //     menuname: "",
          //     people: 1,
          //     vendorid: "",
          //     remarks: "",
          //     checked: false,
          //   };
          //   this.vmodel.items = [...this.vmodel.items, newItem];
          //   index = this.vmodel.items.length - 1;
          //   this.vmodel.items[index].itemid = data;
          //   await this.items
          //     .filter((x) =>
          //       x.submenu.some(
          //         (subElement) =>
          //           subElement.id === this.vmodel.items[index].itemid
          //       )
          //     )
          //     .map((element) => {
          //       element.sub = element.submenu
          //         .filter((subElement) => subElement.id == data)
          //         .map((x) => {
          //           let newElt = Object.assign({}, x);
          //           return newElt;
          //         });
          //       this.vmodel.items[index].submenuid = element.sub[0].id;
          //       this.vmodel.items[index].name = element.sub[0].name;
          //       this.vmodel.items[index].menuid = element.sub[0].menuid;
          //       this.vmodel.items[index].menuname = element.name;
          //       this.vmodel.items[index].people = this.vmodel.noofperson;
          //       this.vmodel.items[index].remarks = "";
          //       this.vmodel.items[index].checked = false;
          //     });
          // }
          await this.getItemListDetails(this.openIndex);
        }
        this.openIndex = "";
      }
    },
    openMultiEventVendorPopup(eventindex, index) {
      this.showVendorPopup = true;
      this.openIndex = index;
      this.openMultipleEventIndex = eventindex;
    },
    openVendorPopup(index) {
      this.showVendorPopup = true;
      this.openIndex = index;
    },
    closeVendorPopup() {
      this.showVendorPopup = false;
    },
    async checkVendor(data) {
      this.showVendorPopup = false;
      await this.getVendor();
      if (this.multipleevents) {
        if (this.vmodel.events) {
          if (this.vmodel.events[this.openMultipleEventIndex].items) {
            this.vmodel.events[this.openMultipleEventIndex].items[
              this.openIndex
            ].vendorid = data;
            await this.getEventItemListDetails(
              this.openIndex,
              this.openMultipleEventIndex
            );
          }
        }
        this.openIndex = "";
      } else {
        if (this.vmodel.items) {
          this.vmodel.items[this.openIndex].vendorid = data;
          await this.getItemListDetails(this.openIndex);
        }
        this.openIndex = "";
      }
    },
    async vendorCheckedMultipleEvents(eventindex, index) {
      if (!this.vmodel.events[eventindex].items[index].checked) {
        this.vmodel.events[eventindex].items[index].vendorid = "";
      }
    },
    async vendorChecked(index) {
      if (!this.vmodel.items[index].checked) {
        this.vmodel.items[index].vendorid = "";
      }
    },
    async editedRecipeCheckedMultipleEvents(eventindex, index) {
      if (!this.vmodel.events[eventindex].items[index].edited) {
        this.vmodel.events[eventindex].items[index].editeditems = [];
      }
    },
    async editedRecipeChecked(index) {
      if (!this.vmodel.items[index].edited) {
        this.vmodel.items[index].editeditems = [];
      }
    },
    async getVendor() {
      this.$root.$globalState.loader = true;
      await APIService.get("/vendor/vender")
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.voption = response.data.data;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
          this.submitted = false;
        });
    },
    onlyDigit($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (
        (this.vmodel.noofperson >= 999999 &&
          keyCode > 47 &&
          keyCode < 58 &&
          keyCode !== 8 &&
          keyCode !== 32) ||
        (this.vmodel.noofperson >= 999999 &&
          keyCode !== 229 &&
          keyCode !== 8 &&
          keyCode !== 32)
      )
        $event.preventDefault();
    },
    onCancel() {
      this.$router.push({ name: "Event" });
    },
    async multipleEventSet() {
      if (this.multipleevents) {
        this.vmodel.eventtype = "";
        this.vmodel.venue = "";
        this.vmodel.events = [];
        this.vmodel.items = [];
        this.addedItemList = [];
        this.addedEventItemList = [];
        if (this.isSelectedRecipe) {
          await this.getRecipe();
          this.vmodel.events = [
            {
              eventtype: "",
              time: "",
              people: this.vmodel.noofperson,
              venue: "",
              hasRecipe: false,
              items: [
                {
                  recipename: "",
                  itemid: "",
                  recipeid: "",
                  people: this.vmodel.noofperson,
                  vendorid: "",
                  remarks: "",
                  checked: false,
                  edited: false,
                  editeditems: [],
                },
              ],
            },
          ];
        } else {
          await this.getsubmenu();
          this.vmodel.events = [
            {
              eventtype: "",
              time: "",
              people: this.vmodel.noofperson,
              venue: "",
              hasRecipe: false,
              items: [
                {
                  name: "",
                  itemid: "",
                  submenuid: "",
                  menuid: "",
                  menuname: "",
                  people: this.vmodel.noofperson,
                  vendorid: "",
                  remarks: "",
                  checked: false,
                  edited: false,
                  editeditems: [],
                },
              ],
            },
          ];
        }
      } else {
        this.vmodel.events = [];
        this.vmodel.items = [];
        this.addedItemList = [];
        this.addedEventItemList = [];
        if (this.isSelectedRecipe) {
          await this.getRecipe();
          this.vmodel.items = [
            {
              recipename: "",
              itemid: "",
              recipeid: "",
              people: this.vmodel.noofperson,
              vendorid: "",
              remarks: "",
              checked: false,
              edited: false,
              editeditems: [],
            },
          ];
        } else {
          await this.getsubmenu();
          this.vmodel.items = [
            {
              name: "",
              itemid: "",
              submenuid: "",
              menuid: "",
              menuname: "",
              people: this.vmodel.noofperson,
              vendorid: "",
              remarks: "",
              checked: false,
              edited: false,
              editeditems: [],
            },
          ];
        }
      }
    },
    async emptyItemList() {
      if (this.multipleevents) {
        if (
          this.$route.params.id == undefined ||
          this.$route.params.id == null
        ) {
          this.vmodel.events = [];
          this.vmodel.items = [];
          this.addedItemList = [];
          this.addedEventItemList = [];
          if (this.isSelectedRecipe) {
            await this.getRecipe();
            this.vmodel.events = [
              {
                eventtype: "",
                time: "",
                people: this.vmodel.noofperson,
                venue: "",
                hasRecipe: false,
                items: [
                  {
                    recipename: "",
                    itemid: "",
                    recipeid: "",
                    people: this.vmodel.noofperson,
                    vendorid: "",
                    remarks: "",
                    checked: false,
                    edited: false,
                    editeditems: [],
                  },
                ],
              },
            ];
          } else {
            await this.getsubmenu();
            this.vmodel.events = [
              {
                eventtype: "",
                time: "",
                people: this.vmodel.noofperson,
                venue: "",
                hasRecipe: false,
                items: [
                  {
                    name: "",
                    itemid: "",
                    submenuid: "",
                    menuid: "",
                    menuname: "",
                    people: this.vmodel.noofperson,
                    vendorid: "",
                    remarks: "",
                    checked: false,
                    edited: false,
                    editeditems: [],
                  },
                ],
              },
            ];
          }
        } else {
          if (this.isSelectedRecipe) {
            await this.getRecipe();
            if (this.vmodel.events && this.vmodel.events.length > 0) {
              for (let i = 0; i < this.vmodel.events.length; i++) {
                let event = this.vmodel.events[i];

                // Loop through items and reset their properties
                for (let j = 0; j < event.items.length; j++) {
                  let item = event.items[j];

                  item.name = "";
                  item.itemid = "";
                  item.submenuid = "";
                  item.menuid = "";
                  item.menuname = "";
                  item.people = event.people; // Default people value, can be adjusted
                  item.vendorid = "";
                  item.remarks = "";
                  item.checked = false;
                  item.edited = false;
                  item.editeditems = []; // Reset the edited items array
                }
              }
            }
          } else {
            await this.getsubmenu();
            if (this.vmodel.events && this.vmodel.events.length > 0) {
              for (let i = 0; i < this.vmodel.events.length; i++) {
                let event = this.vmodel.events[i];

                // Loop through items and reset their properties
                for (let j = 0; j < event.items.length; j++) {
                  let item = event.items[j];

                  item.name = "";
                  item.itemid = "";
                  item.submenuid = "";
                  item.menuid = "";
                  item.menuname = "";
                  item.people = event.people; // Default people value, can be adjusted
                  item.vendorid = "";
                  item.remarks = "";
                  item.checked = false;
                  item.edited = false;
                  item.editeditems = []; // Reset the edited items array
                }
              }
            }
          }
        }
      } else {
        this.vmodel.events = [];
        this.vmodel.items = [];
        this.addedItemList = [];
        this.addedEventItemList = [];
        if (this.isSelectedRecipe) {
          await this.getRecipe();
          this.vmodel.items = [
            {
              recipename: "",
              itemid: "",
              recipeid: "",
              people: this.vmodel.noofperson,
              vendorid: "",
              remarks: "",
              checked: false,
              edited: false,
              editeditems: [],
            },
          ];
        } else {
          await this.getsubmenu();
          this.vmodel.items = [
            {
              name: "",
              itemid: "",
              submenuid: "",
              menuid: "",
              menuname: "",
              people: this.vmodel.noofperson,
              vendorid: "",
              remarks: "",
              checked: false,
              edited: false,
              editeditems: [],
            },
          ];
        }
      }
    },
    async getEventItemListDetails(index, eventIndex) {
      console.log("this is calling");
      console.log(this.addedEventItemList, "this.addedEventItemList");
      let item = this.vmodel.events[eventIndex].items[index];

      console.log(item, "items");

      // Ensure the addedEventItemList exists for this event
      if (this.addedEventItemList && !this.addedEventItemList[eventIndex]) {
        this.addedEventItemList[eventIndex] = [];
      }

      console.log(this.addedEventItemList, "this.addedEventList");

      // Check if the item is already in the addedEventItemList for this event
      let check1 = this.addedEventItemList[eventIndex].indexOf(item.itemid);
      if (check1 !== -1 && index !== check1) {
        item.itemid = "";
        if (this.isSelectedRecipe) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Recipe already added.",
            life: 3000,
          });
          return;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Sub Menu already added.",
            life: 3000,
          });
          return;
        }
      }

      // Add the item ID to the addedEventItemList for the specific event
      if (this.addedEventItemList[eventIndex].length > 0) {
        if (this.addedEventItemList[eventIndex][index]) {
          this.addedEventItemList[eventIndex][index] = item.itemid;
        } else {
          this.addedEventItemList[eventIndex].push(item.itemid);
        }
      } else {
        this.addedEventItemList[eventIndex].push(item.itemid);
      }

      // Handle if it's a recipe or submenu
      if (this.isSelectedRecipe) {
        await this.items
          .filter((x) => x.id === item.itemid)
          .map((data) => {
            item.recipeid = item.itemid;
            item.recipename = data.name;
            item.people = this.vmodel.noofperson;
            item.remarks = "";
          });
      } else {
        await this.items
          .filter((x) =>
            x.submenu.some((subElement) => subElement.id === item.itemid)
          )
          .map((element) => {
            element.sub = element.submenu
              .filter((subElement) => subElement.id === item.itemid)
              .map((x) => {
                let newElt = Object.assign({}, x);
                return newElt;
              });
            item.submenuid = element.sub[0].id;
            item.name = element.sub[0].name;
            item.menuid = element.sub[0].menuid;
            item.menuname = element.name;
            item.people = this.vmodel.noofperson;
            item.remarks = "";
          });
      }
    },
    async getItemListDetails(index) {
      let check1 = this.addedItemList.indexOf(this.vmodel.items[index].itemid);
      if (check1 !== -1 && index !== check1) {
        this.vmodel.items[index].itemid = "";
        if (this.isSelectedRecipe) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Recipe already added.",
            life: 3000,
          });
          return;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Sub Menu already added.",
            life: 3000,
          });
          return;
        }
      }

      if (this.addedItemList.length > 0) {
        if (this.addedItemList[index]) {
          this.addedItemList[index] = this.vmodel.items[index].itemid;
        } else {
          this.addedItemList.push(this.vmodel.items[index].itemid);
        }
      } else {
        this.addedItemList.push(this.vmodel.items[index].itemid);
      }

      if (this.isSelectedRecipe) {
        await this.items
          .filter((x) => x.id === this.vmodel.items[index].itemid)
          .map((data) => {
            this.vmodel.items[index].recipeid = this.vmodel.items[index].itemid;
            this.vmodel.items[index].recipename = data.name;
            this.vmodel.items[index].people = this.vmodel.noofperson;
            this.vmodel.items[index].remarks = "";
          });
      } else {
        await this.items
          .filter((x) =>
            x.submenu.some(
              (subElement) => subElement.id === this.vmodel.items[index].itemid
            )
          )
          .map((element) => {
            element.sub = element.submenu
              .filter(
                (subElement) =>
                  subElement.id === this.vmodel.items[index].itemid
              )
              .map((x) => {
                let newElt = Object.assign({}, x);
                return newElt;
              });
            this.vmodel.items[index].submenuid = element.sub[0].id;
            this.vmodel.items[index].name = element.sub[0].name;
            this.vmodel.items[index].menuid = element.sub[0].menuid;
            this.vmodel.items[index].menuname = element.name;
            this.vmodel.items[index].people = this.vmodel.noofperson;
            this.vmodel.items[index].remarks = "";
          });
      }
    },
    async getsubmenu() {
      this.itemList = [];
      this.items = [];
      this.$root.$globalState.loader = true;
      await APIService.get("/menu/dropdown/onlysubmenu")
        .then((response) => {
          if (response && response.data && response.data.success) {
            this.itemList = response.data.data;
            this.items = response.data.data;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
          this.submitted = false;
        });
    },
    async getRecipe() {
      this.itemList = [];
      this.items = [];
      this.$root.$globalState.loader = true;
      await APIService.get("/recipe/recipe")
        .then((response) => {
          if (response && response.data && response.data.success) {
            this.itemList = response.data.data;
            this.items = response.data.data;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
          this.submitted = false;
        });
    },
    repeateAgain() {
      let newItem;
      if (this.isSelectedRecipe) {
        newItem = {
          recipename: "",
          itemid: "",
          recipeid: "",
          vendorid: "",
          people: this.vmodel.noofperson,
          remarks: "",
          checked: false,
          edited: false,
          editeditems: [],
        };
      } else {
        newItem = {
          name: "",
          submenuid: "",
          itemid: "",
          menuid: "",
          menuname: "",
          vendorid: "",
          people: this.vmodel.noofperson,
          remarks: "",
          checked: false,
          edited: false,
          editeditems: [],
        };
      }
      this.vmodel.items = [...this.vmodel.items, newItem];
    },
    removeItem(index) {
      this.addedItemList.splice(index, 1);
      this.vmodel.items.splice(index, 1);
    },
    repeateAgainEventItem(index) {
      let newItem;
      if (this.isSelectedRecipe) {
        newItem = {
          recipename: "",
          itemid: "",
          recipeid: "",
          vendorid: "",
          people: this.vmodel.events[index].people,
          remarks: "",
          checked: false,
          edited: false,
          editeditems: [],
        };
      } else {
        newItem = {
          name: "",
          submenuid: "",
          itemid: "",
          menuid: "",
          menuname: "",
          vendorid: "",
          people: this.vmodel.events[index].people,
          remarks: "",
          checked: false,
          edited: false,
          editeditems: [],
        };
      }
      this.vmodel.events[index].items = [
        ...this.vmodel.events[index].items,
        newItem,
      ];
    },
    removeEventItem(eventindex, index) {
      if (this.addedEventItemList && this.addedEventItemList.length > 0) {
        this.addedEventItemList[eventindex].splice(index, 1);
      }
      this.vmodel.events[eventindex].items.splice(index, 1);
    },
    repeateAgainEvent() {
      let newItem;
      if (this.isSelectedRecipe) {
        newItem = {
          eventtype: "",
          time: "",
          people: this.vmodel.noofperson,
          venue: "",
          hasRecipe: false,
          items: [
            {
              recipename: "",
              itemid: "",
              recipeid: "",
              vendorid: "",
              people: this.vmodel.noofperson,
              remarks: "",
              checked: false,
              edited: false,
              editeditems: [],
            },
          ],
        };
      } else {
        newItem = {
          eventtype: "",
          time: "",
          people: this.vmodel.noofperson,
          venue: "",
          hasRecipe: false,
          items: [
            {
              name: "",
              submenuid: "",
              itemid: "",
              menuid: "",
              menuname: "",
              vendorid: "",
              people: this.vmodel.noofperson,
              remarks: "",
              checked: false,
              edited: false,
              editeditems: [],
            },
          ],
        };
      }
      this.vmodel.events = [...this.vmodel.events, newItem];
    },
    removeItemEvent(index) {
      this.vmodel.events.splice(index, 1);
    },
    async getCustomerDrop() {
      this.$root.$globalState.loader = true;
      await APIService.get("/customer/customer")
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.customerOption = response.data.data;
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
          this.submitted = false;
        });
    },
    async createEvent() {
      this.validated = true;
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      else {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        this.$root.$globalState.loader = true;
        if (this.multipleevents) {
          if (this.vmodel.events && this.vmodel.events.length > 0) {
            this.vmodel.events.forEach((event) => {
              event.time = DateFormat.setTime(event.time); // Set the formatted time for each event
            });
          }
        }
        let payload = {
          customerid: this.vmodel.customerid,
          eventname: this.vmodel.name,
          people: this.vmodel.noofperson,
          status: this.vmodel.status,
          venue: this.vmodel.venue,
          date: this.vmodel.date,
          time: DateFormat.setTime(this.vmodel.date),
          items: this.vmodel.items,
          eventtype: this.vmodel.eventtype,
          multipleevents: this.multipleevents,
          events: this.vmodel.events,
        };

        this.submitted = true;
        if (this.$route.params.id) {
          await APIService.put("/event", payload, this.$route.params.id)
            .then((response) => {
              if (response && response.data && response.data.success) {
                this.$toast.add({
                  severity: "success",
                  summary: "Success",
                  detail: response.data.message,
                  life: 3000,
                });
                setTimeout(() => {
                  this.$router.push({ name: "Event" });
                });
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: response.data.message,
                  life: 3000,
                });
              }
            })
            .finally(() => {
              this.submitted = false;
              this.$root.$globalState.loader = false;
            });
        } else {
          await APIService.post("/customerevent", payload)
            .then((response) => {
              if (response && response.data && response.data.success) {
                this.$toast.add({
                  severity: "success",
                  summary: "Success",
                  detail: response.data.message,
                  life: 3000,
                });

                setTimeout(() => {
                  this.$router.push({ name: "Event" });
                });
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: response.data.message,
                  life: 3000,
                });
              }
            })
            .finally(() => {
              this.submitted = false;
              this.$root.$globalState.loader = false;
            });
        }
      }
    },
    async getEventById() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      this.$root.$globalState.loader = true;
      await APIService.getById("/event", this.$route.params.id)
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.vmodel.customerid = response.data.data.customerid;
            this.vmodel.name = response.data.data.eventname;
            this.vmodel.noofperson = response.data.data.people;
            this.vmodel.status = response.data.data.status;
            this.vmodel.venue = response.data.data.venue;
            this.vmodel.eventtype = response.data.data.eventtype;
            this.vmodel.date = new Date(
              DateFormat.formatDateTime(response.data.data.eventdate)
            );
            this.item = response.data.data.items;
            this.vmodel.items = response.data.data.items;
            this.isSelectedRecipe = response.data.data.hasRecipe;
            if (
              response.data.data.items &&
              response.data.data.items.length > 0
            ) {
              for (let item of response.data.data.items) {
                if (response.data.data.hasRecipe) {
                  item.itemid = item.recipeid;
                } else {
                  item.itemid = item.submenuid;
                }
                if (item.vendorid) {
                  item.checked = true;
                } else {
                  item.checked = false;
                }
              }
            }
            if (this.vmodel.items && this.vmodel.items.length > 0) {
              this.addedItemList = this.vmodel.items.map((x) => x.itemid);
            }
            if (
              response.data.data.multipleevents !== undefined ||
              response.data.data.multipleevents !== null
            ) {
              this.multipleevents = response.data.data.multipleevents;
            }
            if (
              response.data.data.events &&
              response.data.data.events.length > 0
            ) {
              this.vmodel.events = response.data.data.events;
            }
            if (
              response.data.data.events &&
              response.data.data.events.length > 0
            ) {
              for (let event of response.data.data.events) {
                if (event.items && event.items.length > 0) {
                  for (let item of event.items) {
                    // Set item.itemid based on hasRecipe
                    if (response.data.data.hasRecipe) {
                      item.itemid = item.recipeid; // Set itemid to recipeid if hasRecipe is true
                    } else {
                      item.itemid = item.submenuid; // Set itemid to submenuid if hasRecipe is false
                    }

                    // Set checked based on whether vendorid exists
                    item.checked = item.vendorid ? true : false;
                  }
                }
              }
            }
            if (this.vmodel.events && this.vmodel.events.length > 0) {
              this.addedEventItemList = this.vmodel.events.map((event) => {
                // Initialize the array to hold item IDs for the current event
                let eventItems = [];

                if (event.items && eventItems.length > 0) {
                  // Loop through the event items and map the relevant IDs based on hasRecipe
                  event.items.forEach((item) => {
                    // If hasRecipe, we use recipeid, else submenuid
                    if (response.data.data.hasRecipe) {
                      eventItems.push(item.recipeid);
                    } else {
                      eventItems.push(item.submenuid);
                    }
                  });
                }

                // Return the eventItems for the current event
                return eventItems;
              });
            }
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
            setTimeout(() => {
              this.$router.push({ name: "Event" });
            });
          }
        })
        .finally(() => {
          this.submitted = false;
          this.$root.$globalState.loader = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.add-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 10px;
  gap: 8px;
  height: 36px;
  background: #ff9f43 !important;
  border-radius: 8px;
  border: none;
}
.add-button :hover {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 10px;
  gap: 8px;
  height: 36px;
  background: #ff9f43 !important;
  border-radius: 8px;
  border: none;
}

.box {
  border-radius: 8px;
  border: 1px solid #ccc9d6;
  padding: 20px;
  height: auto;
}

.qty-style {
  width: 36px;
  margin-top: -21px;
  border-radius: unset;
  border-left: none;
  border-right: none;
  padding-left: 11px;
}

.bin-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px !important;
  gap: 8px;
  height: 36px;
  width: 36px !important;
  margin-top: 38px;
  margin-left: 61px;
  background: #feeded;
  opacity: 0.4;
  border: 1px solid rgba(241, 71, 71, 0.4);
  border-radius: 4px;
  margin-left: 10px;
  margin-top: 28px;
}

.bin-button:enabled:hover {
  background: #feeded;
  border: 1px solid rgba(241, 71, 71, 0.4);
}
.add-item-button:enabled:hover {
  background: #06253c;
  color: #fff;
  border-color: #06253c;
}
.add-item-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  height: 37px !important;
  width: 37px !important;
  background: #06253c;
  border-radius: 4px;
  border: #06253c;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: #fff;
}
.bin-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px !important;
  gap: 8px;
  height: 36px;
  width: 36px !important;

  background: #feeded;
  opacity: 0.4;
  border: 1px solid rgba(241, 71, 71, 0.4);
  border-radius: 4px;
}

.bin-button:enabled:hover {
  background: #feeded;
  border: 1px solid rgba(241, 71, 71, 0.4);
}

:deep(.p-multiselect-label) {
  height: 48px !important;
}
:deep(.p-inputnumber .p-inputtext) {
  width: 50px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin-left: 31px;
  margin-top: 10px;
  top: -18px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

::v-deep(.p-checkbox.p-cart) {
  display: none;
}

.p-checkbox-checked + .slider {
  background-color: #ff9f43;
}

.p-checkbox:focus + .slider {
  box-shadow: 0 0 1px #ff9f43;
}

.p-checkbox-checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.pad-check {
  padding: 0px 0px 0px 10px !important;
}
</style>
